import { render, staticRenderFns } from "./CustomEmblem.vue?vue&type=template&id=53e0cea9&"
import script from "./CustomEmblem.vue?vue&type=script&lang=js&"
export * from "./CustomEmblem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports